import React from 'react';
import { IconButton, Img } from '@icecreamsocial/components';
import messengerLogo from '../../../assets/messenger.logo.png';
import { isMobileOrTablet } from '../../../utils';

export const MessengerButton = ({ ...rest }) =>
	isMobileOrTablet() && (
		<IconButton border='none' backgroundColor='#0088ff' {...rest}>
			<IconButton.Icon as={Img} src={messengerLogo} elWidth='32px' />
			<IconButton.Text typoSize='1.1em' textColor='bodyInverse'>
				Messenger
			</IconButton.Text>
		</IconButton>
	);
